module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-warning",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-body-vue"
  }, [_c('ul', {
    staticClass: "carSizeContainer"
  }, _vm._l((_vm.ItemsDetails), function(itemsDetail) {
    return _c('li', [_c('div', [_c('router-link', {
      attrs: {
        "to": '/view/0/year/' + itemsDetail.model_year,
        "tag": "a"
      }
    }, [_c('span', [_vm._v(_vm._s(itemsDetail.model_year) + " "), _c('span', [_vm._v("(" + _vm._s(itemsDetail.model_year_count) + ")")])])])], 1)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Año")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-690ebe16", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690ebe16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu/CarYearSideBar.vue
// module id = 120
// module chunks = 0